import { useState } from "react";

function ReachoutModal({ showModal, setShowModal }) {
  const [userEmail, setUserEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [error, setError] = useState("");
  const [address, setAddress] = useState("");

  const handleSubmit = () => {
    // ✅ Phone validation
    const phoneRegex = /^[6-9]\d{9}$/;
    if (!phoneRegex.test(phone)) {
      setError("Please enter a valid 10-digit Indian phone number.");
      return;
    }

    // ✅ Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(userEmail)) {
      setError("Please enter a valid email address.");
      return;
    }

    setError(""); // clear error if valid

    const subject = "Reachout Request from SSP NextGen Website";
    const body = `User Email: ${userEmail}%0D%0APhone Number: ${phone}`;
    window.location.href = `mailto:sspnextgen@gmail.com?subject=${encodeURIComponent(
      subject
    )}&body=${body}`;
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-2xl shadow-lg w-80">
        <h2 className="text-xl font-bold mb-4 text-center text-green-700">
          Contact
        </h2>

        <input
          type="email"
          placeholder="Your Email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
          className="w-full p-2 mb-6 border rounded"
        />

        <input
          type="number"
          placeholder="Phone Number"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          className="w-full p-2 mb-6 border rounded"
        />

        <textarea
          placeholder="Address (e.g., KPHB, Hyderabad)"
          value={address}
          onChange={(e) => {
            setAddress(e.target.value);

            // Auto-resize height
            e.target.style.height = "auto";
            e.target.style.height = e.target.scrollHeight + "px";
          }}
          className="w-full p-2 mb-6 border rounded overflow-hidden resize-none"
        />
        {/* Error message */}
        {error && <p className="text-red-600 text-sm mb-3">{error}</p>}

        <div className="flex justify-between">
          <button
            onClick={() => setShowModal(false)}
            className="px-4 py-2 bg-gray-400 text-white rounded"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded"
          >
            Submit
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Navbar() {
  const [showModal, setShowModal] = useState(false);
  const [toast, setToast] = useState(false);

  return (
    <>
      {/* Navbar */}
      <nav className="bg-white shadow-md fixed top-0 w-full z-50">
        <div className="container mx-auto px-4 py-3 flex flex-col md:flex-row md:justify-between md:items-center">
          {/* Top Left - Brand */}
          <h1 className="text-xl font-bold text-green-700">
            SSP NextGen E-Bikes
          </h1>

       

          {/* Right - Nav links (hidden on small screens) */}
          <div className="space-x-4 hidden md:flex">
            <a href="#about" className="hover:text-green-700">
              About
            </a>
            <a href="#products" className="hover:text-green-700">
              Products
            </a>


           <div className="flex justify-center mt-2 md:mt-0 md:flex-1">
            <button
              className="flex justify-center mt-2 md:mt-0 md:flex-1"
              onClick={() => setShowModal(true)}
            >
              Contact Us
            </button>
          </div>


          </div>
        </div>
      </nav>

      {/* ✅ Toast bar */}
      {toast && (
        <div className="fixed top-16 right-4 bg-green-600 text-white px-4 py-2 rounded shadow-lg animate-slide-in">
          ✅ Welcome SSP Admin
        </div>
      )}

      {/* ✅ Modal */}
      <ReachoutModal showModal={showModal} setShowModal={setShowModal} />
    </>
  );
}
